/**
 * @desc 审核竞拍
 */
import { AuctionAuditForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type AuditAuctionParameter = AuctionAuditForm

const method = 'PUT'
const url = '/trade/operation/auction/audit'

export const auditAuctionApi = (
  data?: AuditAuctionParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

auditAuctionApi.method = method
auditAuctionApi.url = url
